<template>
    <ManualSection :header="header" :open="open && !isDisabled" :state="state" @click="$emit('click')" code="request">
        <template v-slot:comment>
            <template v-if="membershipRequest">
                <p v-if="membershipRequest.paid" class="cmnt">
                  Вы оплатили членский взнос, заявка в обработке.
                </p>
                <p class="badge badge-warning cmnt" v-else>Заявка не оплачена</p>

                <p class="cmnt" v-if="!open">{{ membershipRequest.typeOfMembership === 'entrance' ? ((membershipRequest.group) ? 'Групповое оформление' : 'Оформление') : ((membershipRequest.group) ? 'Групповое продление' : 'Продление') }} членства на срок {{ period }}{{ membershipRequest.student ? ' для студентов' : ((membershipRequest.discount || membershipRequest.group) ? ' со скидкой 50%' : '') }},
                стоимостью {{ membershipRequest.price }} рублей.</p>
                <p v-if="membershipRequest.group && !open" class="cmnt">
                  Организатор группы: {{ membershipRequest.organizer }}
                </p>
                <p class="text-warning cmnt" v-if="membershipRequest.group && !membershipRequest.groupRequests.length && !open">Кроме вас в группе пока нет ни одного участника.</p>
                <p v-if="!membershipRequest.group && cardReceiveTitle && !open" class="text-info cmnt">
                  Способ получения карты — {{ cardReceiveTitle }}.
                </p>
            </template>
            <template v-else-if="isDisabled">
                <p class="text-danger cmnt">Необходимо заполнить паспортные и контактные данные.</p>
            </template>
        </template>
        <MembershipRequest v-if="membershipRequest && !canceled" cancelTitle="Отправить другую заявку" @cancel="canceled = true" />
        <MembershipPayment :memberStatus="memberStatus" :accept="true" :open="true" v-else />
    </ManualSection>
</template>

<script>
import MembershipPayment from '@/components/MembershipPayment.vue'
import ManualSection from '@/components/ManualSection.vue'
import MembershipRequest from '@/components/MembershipRequest.vue'

export default {
    props: {
        header: String,
        open: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        MembershipPayment,
        MembershipRequest,
        ManualSection,
    },
    data() {
        return {
            canceled: false,
        };
    },
    computed: {
        memberStatus() {
            return this.$store.getters.getUserData.memberInfo?.status      // статус членства
        },
        membershipRequest() {
          return this.$store.getters.getUserData.memberInfo?.membershipRequest
        },
        period() {
          const leadPeriodYears = this.membershipRequest?.leadPeriodYears
          if (leadPeriodYears == 1) return '1 год'
          else if (leadPeriodYears == 3) return '3 года'
          else if (leadPeriodYears == 100) return 'пожизненно'
          return ''
        },
        state() {
            if (!this.membershipRequest) return 'danger';
            return 'success'
        },
        cardReceiveTitle() {
          if ('post' === this.membershipRequest?.cardReceive) {
            return 'почтой';
          }

          if ('personally' === this.membershipRequest?.cardReceive) {
            return 'лично, в офисе АОПА';
          }

          return null;
        },
        passportDataFilled() {
            return this.$store.getters.isUserPassportDataFilled
        },
        baseDataFilled() {
            return this.$store.getters.isUserDataFilled
        },
        isDisabled() {
            return !this.passportDataFilled || !this.baseDataFilled;
        }
    }
}
</script>
